module.exports = __webpack_public_path__ + "static/media/laurels.c2d7d58a.png";